import { BaseSettings, BaseThemeType } from 'Shared/frontend/themes/BaseSettings';
import { merge } from 'Shared/common/merge';
import { DeepPartial } from 'Shared/frontend/SettingsProvider';
import { NotoSerif } from 'Shared/frontend/fonts/NotoSerif';
import { KiwiMaru } from 'Shared/frontend/fonts/KiwiMaru';

import { Home as FrontendHome } from 'Shared/frontend/icons/Home';
import { Calendar as FrontendCalendar } from 'Shared/frontend/icons/Calendar';
import { Contact as FrontendContact } from 'Shared/frontend/icons/Contact';
import { FoodMenu as FrontendMenu } from 'Shared/frontend/icons/FoodMenu';

import { Home as BackendHome } from 'Shared/backend/icons/Home';
import { Calendar as BackendCalendar } from 'Shared/backend/icons/Calendar';
import { FoodMenu as BackendMenu } from 'Shared/backend/icons/FoodMenu';
import { InfoCircle as BackendInfoCircle } from 'Shared/backend/icons/InfoCircle';


export class TheDockSettings extends BaseSettings
{
	palette()
	{
		return {
			background: 'black',
			text: '#E2E2E2',
			feature: '#FCB03B',

			/* Eg the mobile nav colour */
			dimBackground: '#1C1513',

			food: '#B42111',
			drinks: '#FCB03B',
		};
	}

	fontIncludes()
	{
		return [ 
			NotoSerif,
			KiwiMaru
		];
	}

	fonts()
	{
		return {
			text: '"Noto Serif", serif',
			heading: '"Kiwi Maru", serif',
			buttons: '"Kiwi Maru", serif',
			desktopNav: '"Kiwi Maru", serif',
			mobileNav: '"Kiwi Maru", serif',
			subNav: '"Noto Serif", serif',
		};
	}

	text()
	{
		return merge(super.text(), {
			pageTitle: {
				color: this.palette().feature,
				fontWeight: 500,
				lineHeight: 1.3,
				textTransform: 'uppercase',
				textAlign: 'center',
				margin: '32px 0px 24px'
			},
			title: {
				color: this.palette().feature,

				fontWeight: 500,
				lineHeight: 1.3,
				textTransform: 'uppercase',
				margin: '16px 0'
			},
		});
	}

	page()
	{
		return merge(super.page(), {
			button: {
				backgroundColor: this.palette().dimBackground,
				borderRadius: '0.4em'
			},
		});
	}

	siteTheme()
	{
		const base = super.siteTheme();
		const palette = this.palette();

		//Defaults to 'General' unless uncommented and altered
		/*base.specials = {
			general: 'General',
			beers: 'Beers'
		};
		*/

// @ts-expect-error	
		const settings = merge(base, <DeepPartial<BaseThemeType>>{

			event: {
				subNav: {
					...this.button().hollow,
				},

				heading: {
					...this.fontsHeading(),
					fontSize: '2em',
					lineHeight: 1.1,
					textTransform:'uppercase',
				},
				artist: {
					heading: {
						color: palette.feature,
					},
					wide: {
						nameAndTime: {
							color: palette.feature
						}
					},
					narrow: {
						nameAndTime: {
							backgroundColor: palette.feature
						}
					}, 
					genresAndLocation: {
						color: palette.feature
					} 
				}
			},

			//TODO share most of this with the townie. eg 'ColouredDarkTheme' parent
			menu: {

				subNav: {
					...this.button().hollow,
				},
				section: {
					h3: {
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,40,60),
		
					},
					marginBottom: '3em'
				},
				item: {
					type: 'imageless',
					title: { 
					...this.fontsHeading(),
					},
				},
			},
//probably doesn't do anything
			subNavButton: {
				borderRadius: '0.4em'
			},
		});
		// XXX if we want to entirely remove or overwrite a base setting or two then do so here 
		return settings;
	}

	pages()
	{
		return [
			{
				key: 'home',
				frontend: {
					route: '/',
					metaTitle: 'Home'
				},
				backend: {
					route: '/home',
					title: 'Home'
				}
			},
			{
				key: 'events',
				frontend: {
					route: '/events',
					metaTitle: 'Events'
				},
				backend: {
					route: '/events-design',
					title: 'Events'
				}
			},
			{
				key: 'book',
				frontend: {
					route: '/book',
					metaTitle: 'Book'
				},
				backend: {
					route: '/book',
					title: 'Book'
				}
			},
			{
				key: 'hire',
				frontend: {
					route: '/hire',
					metaTitle: 'Hire'
				},
				backend: {
					route: '/hire',
					title: 'Hire'
				}
			},
			{
				key: 'contact',
				frontend: {
					route: '/contact',
					metaTitle: 'Contact'
				},
				backend: {
					route: '/contact',
					title: 'Contact'
				}
			},
		];
	}

	navContent()
	{
		return ({
			desktop: [
				{label:'Home',		link:'frontend/Home'},
				{label:'Menu',		link:'frontend/Menu'},
				{label:'Events',	link:'frontend/Events'},
				{label:'Contact',	link:'frontend/Contact'}
			],
			mobile: {
				maxButtons: 5,
				includeMoreButton: true,
				links: [
					{label:'Home',		link:'frontend/Home',		icon: FrontendHome},
					{label:'Menu',		link:'frontend/Menu',		icon: FrontendMenu},
					{label:'Events',	link:'frontend/Events',		icon: FrontendCalendar},
					{label:'Contact',	link:'frontend/Contact',	icon: FrontendContact},
				]
			}
		});
	}

	backendNavContent()
	{
		return [
			{label:'Home',		route:'/admin/home',			icon:BackendHome},
			{label:'Events',	route:'/admin/events',			icon:BackendCalendar},
			{label:'Menu',		route:'/admin/menus',			icon:BackendMenu},
			{label:'Info',		route:'/admin/contact',			icon:BackendInfoCircle},
		];
	}
};

function menuItemTitleColour(palette,productType,section)
{
	if (productType == 'food')
		return palette.food;
	else
		return palette.feature;
}

function menuNavButtonColour(palette,type:string)
{
	switch(type) {
		case 'food': return palette.food;
		case 'drinks': return palette.drinks;
	}
	return 'inherit';
}

